import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import ProductsGallery from '../components/ProductsGallery/ProductsGallery'
import RelatedProdtcts from '../components/RelatedProdtcts/RelatedProdtcts'
import ProductInfo from '../components/ProductInfo/ProductInfo'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import ReviewProdtcts from '../components/ReviewProdtcts/ReviewProdtcts'
import TrendingProducts from '../components/TrendingProducts/TrendingProducts'

function ProductDetails() {
  const { id } = useParams(); // Extracts the "id" from the URL
  const [product, setProduct] = useState([])
  const [relatedProduct, setRelatedProduct] = useState([])
  useEffect(() => {
    const getAllApis = async () => {

      await axios
        .get(`https://nanosoft.technology/outlaw/api/products`)
        .then(async (res) => {
                    const product=res.data.data.filter(item=>item?.id==id)
          console.log(product,"productproductproductproductproductproduct");
          
          setProduct(product);

          console.log('res.data',res.data);
          

        })
        .catch((error) => {

          console.log(error);


        });
      await axios
        .get(`https://nanosoft.technology/outlaw/api/products/${id}/related`)
        .then(async (res) => {
          
          setRelatedProduct(res.data.data);

          console.log('res.data',res.data.data);
          

        })
        .catch((error) => {

          console.log(error);


        });
    }
    getAllApis()
  }, [id])

  return (
    <div>
      <NavbarContainer />
      <Container>
        <Row>
          <Col md={6}>
            <ProductsGallery
              images={product && product?.[0]?.images}
              info={product && product?.[0]}
            />
          </Col>
          <Col md={6}>
            <ProductInfo
              info={product && product?.[0]}
            />
          </Col>
        </Row>
        <Row>
          {/* <ReviewProdtcts
            products={product && product.relatedProducts}
          /> */}
        </Row>
        <Row>
          <h4 className='mb-3 mt-4'>Redlated Products</h4>
          {relatedProduct.length>0&&
          <TrendingProducts
            products={relatedProduct && relatedProduct}
          />
}
        </Row>
      </Container>
      <Footer />
    </div>
  )
}

export default ProductDetails